// extracted by mini-css-extract-plugin
export default {"pageTitle":"_1ndKI"};